import React from 'react';
import ReviewTable from './components/ReviewTable';

const Review = () => {
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Review</h1>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20" style={{ minHeight: 540 }}>
          <ReviewTable />
        </div>
      </div>
    </div>
  );
};

export default Review;
